/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var $node = document.getElementById('titleWidget'),
    title = {},
    $number = document.getElementById('titleWidgetNumber'),
    $title = document.getElementById('titleWidgetName'),
    $favorite = document.getElementById('icon-favorite'),
    $time = document.getElementById('titleWidgetTime'),
    timer;


title.set = function ( ch ) {
    ch = ch || {};
    $title.innerText  = ch.name || '';
    $number.innerText = ch.number || '';
    // $favorite.innerText = ch.favorite ? 'C' : ' ';
    if ( ch.favorite ) {
        $favorite.classList.remove('hidden');
    } else {
        $favorite.classList.add('hidden');
    }

    if ( ch.epg ) {
        $title.innerText += '\n' + ch.epg;
    }
};

function doTime () {
    var time = new Date();

    $time.innerText = ( '0' + time.getHours()).slice(-2) + ':' + ( '0' + time.getMinutes()).slice(-2);
}

title.display = function ( config, time ) {
    time = time || 5000;
    if ( !title.visible ) {
        title.show();
    }
    if ( config.background ) {
        $node.classList.add('bg');
    }
    clearTimeout(timer);

    timer = setTimeout(function () {
        if ( config.background ) {
            //$node.classList.remove('bg');
            //title.hide();
        }
    }, time);
};

doTime();

setInterval(doTime, 35000);

module.exports = title;
